<div class="modal-header">
  <div>
    <h5 class="modal-title mt-0 mb-2" id="modal-basic-title">{{ 'INTERNAL_NOTE_FOR_ARTNR' | translate : { articlenumber: articleNumber } }}</h5>
    <span translate>INTERNAL_NOTE_FOR_ARTNR_DESCRIPTION</span>
  </div>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="col-12">
    <div class="form-group">
      <textarea
        rows="5"
        class="form-control"
        type="text"
        name="note"
        id="note"
        [(ngModel)]="note"
        [maxlength]="maxLength"
        ngbAutofocus
      ></textarea>
    </div>
  </div>

  @if(!!maxLength) {
    <span class="text-muted">
      {{ 'INTERNAL_NOTE_MAX_LENGTH' | translate : { length: maxLength } }}
    </span>
  }
</div>

<div class="modal-footer">
  <div class="row w-100">
    <div class="col-12">
      <div class="btn-group btn-group-justified w-100">
        <button class="btn btn-sm btn-outline-secondary btn-default" (click)="close()" translate>CANCEL</button>
        <button class="btn btn-sm btn-primary btn-default" (click)="save()" translate>SAVE</button>
      </div>
    </div>
  </div>
</div>
